module.exports = __webpack_public_path__ + "img/psbLog.88e642ae.png";